module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Foreword")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-introduction has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Who Are You?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Christ-Centered Fitness")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A Transformed Life Through a Transformed Mind")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("4. ")]), _c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Faith and Fitness")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("5. ")]), _c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Physically Fit People in the Bible")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("6. ")]), _c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Christ-Centered Workouts")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("7. ")]), _c('a', {
    attrs: {
      "href": "#/chapter007"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Strength Training Workouts")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("8. ")]), _c('a', {
    attrs: {
      "href": "#/chapter008"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Dynamic Home Workouts")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("9. ")]), _c('a', {
    attrs: {
      "href": "#/chapter009"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Cardio Kings and Queens")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("10. ")]), _c('a', {
    attrs: {
      "href": "#/chapter010"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Workout Principles")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("11. ")]), _c('a', {
    attrs: {
      "href": "#/chapter011"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Law of Sowing and Reaping")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("12. ")]), _c('a', {
    attrs: {
      "href": "#/chapter012"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Revealing the Keys to Nutrition")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("13. ")]), _c('a', {
    attrs: {
      "href": "#/chapter013"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Can We Skip Nutrients?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("14. ")]), _c('a', {
    attrs: {
      "href": "#/chapter014"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A Chosen Generation: What the Future Holds")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/salvationprayer"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Salvation Prayer")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/beforeyougo"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Before You Go…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheauthor"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/workscited"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Works Cited")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0